/** Limite dos campos Complemento Evento / Complemento Entrega no Salesforce. */
export const SALESFORCE_COMPLEMENTO_MAX_LENGTH = 255;

export function limitComplemento(value: string | null | undefined): string {
  if (value == null) return '';
  return String(value).slice(0, SALESFORCE_COMPLEMENTO_MAX_LENGTH);
}
